import React from 'react';
import classNames from 'classnames';
import { FormattedMessage } from '../../util/reactIntl';
import { LINE_ITEM_SHIPPING_FEE } from '../../util/types';

import css from './OrderBreakdown.module.css';
import pendingCss from './LineItemShippingPendingMaybe.module.css';

/**
 * CL-SHIP-02. Shipping is priced from the buyer's delivery country, so before
 * an address exists there is no fee to show. Showing nothing would present a
 * total that silently excludes shipping; showing a domestic figure would show a
 * number that is about to change. Neither is allowed, because the price the
 * buyer is shown is binding (decision D3).
 *
 * @component
 * @param {Object} props
 * @param {Array} props.lineItems - the line items filtered for this user role
 * @param {string} [props.deliveryMethod] - 'shipping' | 'pickup' | undefined
 * @returns {JSX.Element|null}
 */
const LineItemShippingPendingMaybe = props => {
  const { lineItems, deliveryMethod } = props;

  if (deliveryMethod !== 'shipping') return null;

  const hasShippingFee = lineItems.some(
    item => item.code === LINE_ITEM_SHIPPING_FEE && !item.reversal
  );
  if (hasShippingFee) return null;

  return (
    <div className={css.lineItem}>
      <span className={css.itemLabel}>
        <FormattedMessage id="OrderBreakdown.shippingFee" />
      </span>
      <span className={classNames(css.itemValue, pendingCss.pendingValue)}>
        <FormattedMessage id="OrderBreakdown.shippingPending" />
      </span>
    </div>
  );
};

export default LineItemShippingPendingMaybe;
